// extracted by mini-css-extract-plugin
export var wrapper = "RelatedProjects-module--wrapper--OpxAn";
export var caption = "RelatedProjects-module--caption--9oSJX";